import page from 'page'

import appStarterPg from '../../../config/app-starter-pg.js'
import { contentElementId } from '../../../config/config.js'
import { browserAppUser } from '../../../helpers/app-data-loaders/app-user.js'

import { showAdminListEntities } from './list-entities/index.js'
import { showAdminListEntitiesLedgers } from './list-entities-ledgers/index.js'
import { showAdminLedgersMissingJournals } from './ledgers-missing-journals/index.js'
import { showAdminDuplicatesForAllEntities } from './xero_duplicates/index.js'

/*
  /app/admin/entity/...
*/
export async function adminEntitiesRoutes (baseRoute) {
  // console.log('adminEntitiesRoutes')

  /**
   */
  page(`${baseRoute}`, async function () {
    await appStarterPg()

    showAdminListEntities({
      containerElementId: contentElementId,
      browserAppUser
    })
  })

  /**
   * Jun 11th, 2025
   */
  page(`${baseRoute}/list-ledgers`, async function () {
    await appStarterPg()

    showAdminListEntitiesLedgers({
      containerElementId: contentElementId,
      browserAppUser
    })
  })

  /**
   * Jun 12th, 2025
   */
  page(`${baseRoute}/xero-duplicates/:objectName`, async function (context) {
    const { objectName } = context.params

    await appStarterPg()

    showAdminDuplicatesForAllEntities({
      containerElementId: contentElementId,
      browserAppUser,
      objectName: objectName === 'all' ? null : objectName
    })
  })

  /**
   * Jun 26th, 2025
   */
  page(`${baseRoute}/ledgers-missing-journals`, async function (context) {
    await appStarterPg()

    showAdminLedgersMissingJournals({
      containerElementId: contentElementId,
      browserAppUser
    })
  })
}
